import { Card } from '@/shared/ui/card';
import { Award, Briefcase, Shield, User as UserIcon } from 'lucide-react';
import type { ColorScheme, User } from '../types/user';
import { getThemeColors } from '../utils/themeColors';

interface UserStatsCardsProps {
  user: User;
  colorScheme: ColorScheme;
}

export function UserStatsCards({ user, colorScheme }: UserStatsCardsProps) {
  const colors = getThemeColors(colorScheme);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className={`p-4 bg-gradient-to-br ${colors.stat1} border border-border`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs font-medium ${colors.stat1Text} opacity-70 mb-1`}>Active Jobs</p>
            <p className={`text-2xl font-bold ${colors.stat1Text}`}>{user.activeJobs}</p>
          </div>
          <div
            className={`w-12 h-12 rounded-lg ${colors.stat1Icon} flex items-center justify-center`}
          >
            <Briefcase className="w-6 h-6" />
          </div>
        </div>
        <div className={`mt-2 flex items-center text-xs ${colors.stat1Text} opacity-60`}>
          <span>Currently assigned</span>
        </div>
      </Card>

      <Card className={`p-4 bg-gradient-to-br ${colors.stat2} border border-border`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs font-medium ${colors.stat2Text} opacity-70 mb-1`}>
              Completed Jobs
            </p>
            <p className={`text-2xl font-bold ${colors.stat2Text}`}>{user.completedJobs}</p>
          </div>
          <div
            className={`w-12 h-12 rounded-lg ${colors.stat2Icon} flex items-center justify-center`}
          >
            <Award className="w-6 h-6" />
          </div>
        </div>
        <div className={`mt-2 flex items-center text-xs ${colors.stat2Text} opacity-60`}>
          <span>All-time total</span>
        </div>
      </Card>

      <Card className={`p-4 bg-gradient-to-br ${colors.stat3} border border-border`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs font-medium ${colors.stat3Text} opacity-70 mb-1`}>Team</p>
            <p className={`text-xl font-bold ${colors.stat3Text}`}>{user.team}</p>
          </div>
          <div
            className={`w-12 h-12 rounded-lg ${colors.stat3Icon} flex items-center justify-center`}
          >
            <Shield className="w-6 h-6" />
          </div>
        </div>
        <div className={`mt-2 flex items-center text-xs ${colors.stat3Text} opacity-60`}>
          <span>Primary assignment</span>
        </div>
      </Card>

      <Card className={`p-4 bg-gradient-to-br ${colors.stat4} border border-border`}>
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-xs font-medium ${colors.stat4Text} opacity-70 mb-1`}>Status</p>
            <p className={`text-xl font-bold capitalize ${colors.stat4Text}`}>{user.status}</p>
          </div>
          <div
            className={`w-12 h-12 rounded-lg ${colors.stat4Icon} flex items-center justify-center`}
          >
            <UserIcon className="w-6 h-6" />
          </div>
        </div>
        <div className={`mt-2 flex items-center text-xs ${colors.stat4Text} opacity-60`}>
          <span className="w-2 h-2 rounded-full bg-current mr-1.5 opacity-70"></span>
          <span>Currently online</span>
        </div>
      </Card>
    </div>
  );
}
